import { types } from 'mobx-state-tree';

import AddressSuggestion from 'js/stores/types/AddressSuggestion';

export default types
  .model('AddressInputState', {
    placeId: '',
    addressInput: '',
    suggestions: types.optional(types.array(AddressSuggestion), []),
    requestInProgress: false,
    errorGettingPlacesData: false,
  })
  .views(self => ({
    get hasOneSuggestion() {
      return self.suggestions.length === 1;
    },
    get hasSuggestions() {
      return self.suggestions.length > 0;
    },
    get choiceMade() {
      return !!self.placeId;
    },
  }))
  .actions(self => ({
    setAddressInput(value) {
      self.addressInput = value;
      return self;
    },
    clearSuggestions() {
      self.suggestions = [];
      return self;
    },
    setPlaceId(id) {
      self.placeId = id;
      return id;
    },
    clearPlaceId() {
      self.placeId = '';
      return self;
    },
    setSuggestions(suggestions) {
      self.suggestions = suggestions;
      return self;
    },
    setRequestInProgress(inProgress) {
      self.requestInProgress = inProgress;
      return self;
    },
    setError(error) {
      self.errorGettingPlacesData = error;
      return self;
    },
  }));
